import React from "react";

import { connect } from "react-redux";
import { Formik, Field } from "formik";
import { Alert, AlertTitle } from "@material-ui/lab";

import TextField from "../../components/CstmTextField";
import ScreenWrapper from "../../components/ScreenWrapper";

import { IS_EMAIL } from "../../constants/validations";

import checkResetEmail from "../../actions/checkResetEmail.actions";

const ResetPassword = ({ sendResetPassword, showError }) => {
  return (
    <ScreenWrapper showProgress={false}>
      <Formik
        initialValues={{ email: "" }}
        validate={validate}
        onSubmit={(values) => {
          sendResetPassword(values);
        }}
      >
        {({ handleSubmit }) => (
          <React.Fragment>
            {showError === true && (
              <React.Fragment>
                <Alert severity="error">
                  <AlertTitle>Error</AlertTitle>
                  Invalid Reset Password Code.
                </Alert>
                <br />
              </React.Fragment>
            )}
            <Field
              name="email"
              label="Email Address"
              component={TextField}
              required
            />

            <div style={{ marginTop: 10 }}>
              <div style={{ float: "right" }}>
                <button
                  type="button"
                  className="cstm_btn cstm_btn-blue"
                  onClick={handleSubmit}
                >
                  Send Reset Code
                </button>
              </div>
            </div>
          </React.Fragment>
        )}
      </Formik>
    </ScreenWrapper>
  );
};

const validate = (values) => {
  let errors = {};

  if (!values.email) {
    errors.email = "Required";
  } else if (IS_EMAIL.test(values.email) === false) {
    errors.email = "Invalid email format";
  }

  return errors;
};

const mapState = (state) => {
  return {
    showError: state.resetPassword.showError,
  };
};

const mapDispatch = (dispatch) => {
  return {
    sendResetPassword: (values) => {
      dispatch(checkResetEmail(values));
    },
  };
};

export default connect(mapState, mapDispatch)(ResetPassword);



// WEBPACK FOOTER //
// ./src/Screens/ResetPassword/index.js